import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=7cf3c0e2&scoped=true"
import script from "./Integrations.vue?vue&type=script&setup=true&lang=ts"
export * from "./Integrations.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Integrations.vue?vue&type=style&index=0&id=7cf3c0e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf3c0e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cf3c0e2')) {
      api.createRecord('7cf3c0e2', component.options)
    } else {
      api.reload('7cf3c0e2', component.options)
    }
    module.hot.accept("./Integrations.vue?vue&type=template&id=7cf3c0e2&scoped=true", function () {
      api.rerender('7cf3c0e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/sidebar/Integrations.vue"
export default component.exports